import InspectionComponent from '@/components/Pages/Inspection.vue';
import RouteNames from '../constants/route-names';

const route = {
  path: '/inspection/:folderId',
  props: true,
  name: RouteNames.Inspection,
  component: InspectionComponent,
};

export default route;
